import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TCardProductDesktop, TCardProductMobile } from '../models';

// TODO: Отрефачить компонент:
// - Название с большой буквы
export const renderTopBlock: FC<TCardProductDesktop | TCardProductMobile> = (
    props,
    headingView
) => {
    const {
        Text,
        dataTestId = 'card-product-top-block',
        styles,
        swapTitles,
        textTheme,
        topSubtitle,
        topTitle,
    } = props;

    const primaryText = (
        <Text
            className={cn(styles.external, styles.topTextMarginBottom)}
            dataTestId={`${dataTestId}-top-primary-text`}
            styler={{ margin: 0 }}
            theme={textTheme}
            view={headingView}
        >
            {topTitle}
        </Text>
    );

    const secondaryText = (
        <Text
            className={cn(styles.external, styles.topTextMarginBottom)}
            dataTestId={`${dataTestId}-top-secondary-text`}
            styler={{ marginTop: 0 }}
            theme={textTheme}
            view="primary-medium"
        >
            {topSubtitle}
        </Text>
    );

    return (
        <>
            {swapTitles ? (
                <>
                    {primaryText}
                    {secondaryText}
                </>
            ) : (
                <>
                    {secondaryText}
                    {primaryText}
                </>
            )}
        </>
    );
};
